export enum CAMPAIGN_TYPE_ENUM {
  'email' = 'EMAIL',
  'banner' = 'BANNER',
  'itemsPromotion' = 'PROMO',
  'sponsorship' = 'sponsorship',
  'searchPositioning' = 'searchPositioning',
}

export const CAMPAIGN_TYPE_ENUM_VALUES = Object.values(CAMPAIGN_TYPE_ENUM);

export const CAMPAIGN_PAYMENT_PATH = {
  [CAMPAIGN_TYPE_ENUM.email]: 'campaign',
  [CAMPAIGN_TYPE_ENUM.banner]: 'banner_campaign',
  [CAMPAIGN_TYPE_ENUM.itemsPromotion]: 'promo_campaign',
};

export const AVAILABLE_CAMPAIGN_TYPES = process.env.REACT_APP_CAMPAIGN_TYPES?.split(',') || [CAMPAIGN_TYPE_ENUM.email];

export const STEPS_PER_CAMPAIGN_TYPE = {
  [CAMPAIGN_TYPE_ENUM.banner]: 1,
  [CAMPAIGN_TYPE_ENUM.itemsPromotion]: 2,
  [CAMPAIGN_TYPE_ENUM.sponsorship]: 2,
  [CAMPAIGN_TYPE_ENUM.searchPositioning]: 2,
  [CAMPAIGN_TYPE_ENUM.email]: 4,
};
